import React from "react";

const MasterList = React.lazy(() => import("./MasterList"));

export default {
  list: MasterList,
  recordRepresentation: (record: { name?: string }) => record?.name ?? "",
};
